import { render, staticRenderFns } from "./HuggedValue.vue?vue&type=template&id=5d3249ea&"
import script from "./HuggedValue.vue?vue&type=script&lang=js&"
export * from "./HuggedValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports